import React, { useRef, useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import Colors from 'components/Colors.js';

window.magik = 1.5;
window.rad = 1;
const colors = new Colors();

const WIDTH = 495;
const HEIGHT = 400;
const FULL_RADIUS = (WIDTH/2)*.75;

const SequencerArt = ({displayRef, backgroundColor, color, tidals, total=1, radius=FULL_RADIUS, ...props}) => { 
    let ref = useRef(undefined);
    let ctxt = useRef(undefined);

    useEffect(() => {
        ctxt.current = ref.current.getContext('2d');
        ctxt.current.scale(window.devicePixelRatio, window.devicePixelRatio);
        draw();
    }, []);


    useEffect(() => {
        if (ctxt.current) {
            draw();
        }
    }, [props]);

    const draw = useCallback(() => {
        let c = ctxt.current;
        c.clearRect(0,0,WIDTH,HEIGHT);
        c.beginPath();
        c.rect(0,0,WIDTH,HEIGHT);
        c.fillStyle = backgroundColor;
        c.fill();
        //c.clip();
        for (let nth=0; nth < Math.min(1, tidals.length); nth++) {
            let tidal = tidals[nth];
            let cycle = tidal.cycle;
            
            let flattened = cycle.flat(16);
            let len = flattened.length;
            let hand = false;
            let rad = Math.max(1, 15 - nth*3);
            let cursor ={x: 2*rad, y: 2*rad};
            let isLastDot = false;
            for (let i=0; i < flattened.length; i++) {
                let leaf = flattened[i];
                if (!leaf.type) {
                    continue;
                }
                let {type, value} = leaf.type;
                if (i > 0) {
                    let _rad = leaf.accent ? rad * 2 : rad;
                    if (type === '-') {
                        cursor.x += _rad*3;
                        //cursor.y += _rad*3;
                        if (value === 0) {
                            hand = !hand;
                        } 
                    } else if (type === '.') {
                        if (isLastDot) {
                            cursor.y += _rad*3;
                        }
                        hand = !hand;
                    }
                }

                isLastDot = type === '.';

                let x = cursor.x;
                let y = cursor.y;
                if (hand) {
                    y = HEIGHT - y;
                }

                if (leaf.transpose === null) {
                    continue;
                }

                c.beginPath();
                c.fillStyle = color;
                let _rad = window.rad*rad;
                if (leaf.accent) {
                    _rad*=2;
                }
                let end = 2*Math.PI;
                if (leaf.staccato) {
                    end = Math.PI;
                }
                if (tidal.currentCycles && tidal.currentCycles[leaf.id]) {
                    c.fillStyle = 'red';
                    c.fillStyle = '#FFA47D';
                } 
                if (nth > 0) {
                    c.fillStyle = "gray";
                    _rad = rad;
                }
                c.arc(x,y,_rad,0,end);
                if (leaf.piano || leaf.pianissimo) {
                    c.strokeStyle = color;
                    c.lineWidth = 2;
                    c.stroke();
                } else {
                    c.fill();
                }
                /*
                c.fillStyle='red';
                let h = hand ? 'T' : 'F';
                c.fillText(i+' ' + h, x,y);
                */
            }
            if (nth === 0) {
                cursor.x += rad*4;
                cursor.y += rad*4;
                c.fillStyle = 'black';
                c.fillRect(cursor.x,cursor.y, WIDTH-cursor.x-rad,100);
                if (displayRef.current) {
                    displayRef.current.style.left = cursor.x + 'px';
                    displayRef.current.style.top =cursor.y + 'px';
                    displayRef.current.style.width =(WIDTH-cursor.x)+'px';
                    displayRef.current.style.height=100+'px';
                }
            }
        }
    }, [color, backgroundColor, tidals, total]);

    return (
        <canvas
          className="tidal-art"
          style={{
              width: WIDTH,
              height: HEIGHT,
          }}
          width={WIDTH*window.devicePixelRatio} height={HEIGHT*window.devicePixelRatio} ref={ref}>
        </canvas>);
};

const mapStateToProps = (state, props) => {
    let x = {
    };
    props.tidals.forEach(
        t => {
            x[t.id] = t.currentCycles;
            x["cycle" + t.id] = t.cycle;
        });
    return x;
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SequencerArt);
